<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import config from "../../../config/config";
import { mapGetters, mapActions } from "vuex";

/**
     * Starter component
     */
     export default {
        page: {
            title: "Version",
            meta: [{ name: "description", content: appConfig.description }]
        },
        components: { Layout},
        computed: mapGetters("version", ["getAllVersion","loading","versionCount","pagination"]),
        data() {
            return {
                sortBy: "id",
                sortDesc: true,
                pages: [],
                paginations: {},
                limit: 1,
                search: "",
                config: config,
                    fields: [
                        {
                        key: "ios_version",
                            label: 'Ios Version',
                            sortable: true,
                        },
                        {
                            key: "android_version",
                            label: 'Android Version',
                            sortable: true,
                        },
                        {
                            key: "status",
                            label: 'status',
                            sortable: true,
                        },
                        {
                            key: "action",
                            label: 'Action',
                            sortable: false,
                        },
                    ],
                };
            },
        mounted() {
            this.getVersion();
        },
        methods: {
            ...mapActions('version',["getVersions", "deleteVersion"]),
            getVersion(){
                let page = 1;
                var filters = {
                    search: this.search,
                    sortBy: this.sortBy,
                    orderBy: this.sortDesc ? "desc" : "asc",
                    page: page && page > 0 ? page : 1,
                }
                this.getVersions(filters);
            },
            
            sortingChanged(ctx) {
                this.sortBy = ctx.sortBy;
                this.sortDesc = ctx.sortDesc;
                this.getVersion();
            },
            deleteById(id){
                this.deleteVersion({id:id})
                    .then((response) => {
                    if (response.data.code === 200) {
                        //success_message(response.data.msg);
                        this.getVersion();
                    } else {
                        //error_message(response.data.msg);
                    }
                });
            }
        }
    };
</script>
<template>
    <Layout>
        <div class="row">
            <div class="col-12">
                <div
                class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
                    >
                    <div class="page-title-left d-flex align-items-center">
                        <div class="avatar-xs mr-3">
                            <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                                <i class="bx bx-tag"></i>
                            </span>
                        </div>
                        <!-- <h4 class="mb-0 font-size-18">Versions ({{versionCount}})</h4> -->
                    </div>
                    <div class="page-title-right">
                        <router-link :to="{name: 'general-add'}" class="btn btn-success btn-rounded mr-2 add-btn">
                            <i class="mdi mdi-plus mr-1"></i>
                            Add General Items
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
